import { SxProps, Theme } from "@mui/material/styles";

export const styles = {
  container: {
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "auto 1fr",
      md: "auto minmax(0, 700px)",
    },
    justifyContent: "start",
    columnGap: 1.5,
    rowGap: 1.5,
  } as SxProps<Theme>,
};
